import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

/* A lot of Ionic stuff */

import { IonicVue } from "@ionic/vue";

/* Core CSS required for Ionic components to work properly */
import "@ionic/vue/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/vue/css/normalize.css";
import "@ionic/vue/css/structure.css";
import "@ionic/vue/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/vue/css/padding.css";
import "@ionic/vue/css/float-elements.css";
import "@ionic/vue/css/text-alignment.css";
import "@ionic/vue/css/text-transformation.css";
import "@ionic/vue/css/flex-utils.css";
import "@ionic/vue/css/display.css";

/* Theme variables */
import "./theme/variables.css";

/* Other stuff to import, not ionic */
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import VueVirtualScroller from "vue-virtual-scroller";
import vue3PhotoPreview from "vue3-photo-preview";
import "vue3-photo-preview/dist/index.css";

import { createPinia } from "pinia";

import piniaPersistedState from "pinia-plugin-persistedstate";
import { PiniaSharedState } from "pinia-shared-state";

/* Own stuff */
import { initSentry, sentryPiniaPlugin } from "@/sentry";
import { getApiUrl } from "@/data/constants";

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

const pinia = createPinia();
pinia.use(piniaPersistedState);
pinia.use(sentryPiniaPlugin());
pinia.use(
  PiniaSharedState({
    // Enables the plugin for all stores. Defaults to true.
    enable: true,
    // If set to true this tab tries to immediately recover the shared state from another tab. Defaults to true.
    initialize: false,
    // Enforce a type. One of native, idb, localstorage or node. Defaults to native.
    // type: 'localstorage',
  })
);

const app = createApp(App)
  .use(pinia)
  .use(IonicVue, {
    mode: isSafari ? "ios" : undefined,
  })
  .use(router)
  .use(VueVirtualScroller)
  .use(vue3PhotoPreview);
initSentry(app, router, getApiUrl());
router.isReady().then(() => {
  app.mount("#app");
});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(console.error);
  });
}
